import { AppBar, DialogContent, IconButton, Toolbar, Tooltip, Typography, withStyles } from '@material-ui/core';
import ImageEditor from '@toast-ui/react-image-editor';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import classNames from 'classnames';
import React from 'react';
import { MdAdd } from 'react-icons/md';
import { RiImageEditFill } from 'react-icons/ri';
import 'tui-image-editor/dist/tui-image-editor.css';

const styles = theme => ({
    removeLogo: {
        '& .tui-image-editor-header-logo': {
            display: 'none'
        },
        '& .tui-image-editor-header-buttons': {
            display: 'none'
        },
        '& .tui-colorpicker-clearfix': {
            display: 'flex',
            flexWrap: 'wrap',
        },
        '& .tui-colorpicker-palette-button': {
            width: '25px',
            height: '25px',
        },
        '& .tui-colorpicker-palette-preview': {
            display: 'none'
        },
    },
    addButtonSmall: {
        position: 'absolute',
        right: 50,
        bottom: 12,
        zIndex: 99
    },
    saveButtonSmall: {
        position: 'absolute',
        right: 12,
        bottom: 12,
        zIndex: 99
    },
    addButton: {
        position: 'absolute',
        width: '300px',
        height: '300px',
        top: '200px',
        left: '50%',
        marginLeft: '-150px',
        zIndex: 9999
    },
    board: {
        cursor: 'pointer',
        transitionProperty: 'box-shadow border-color',
        transitionDuration: theme.transitions.duration.short,
        transitionTimingFunction: theme.transitions.easing.easeInOut,
        border: "1px solid #FFF",
        color: "#FFF",
        boxShadow: theme.shadows[6]
    }
});

class EditorImagemApp extends XAPPComponent {

    editorRef = React.createRef();

    state = {
        open: false,
        value: null,
        addButton: true,
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.open && !prevState.open) {
            this.setState({ value: null });
        }

        if (this.state.open && document.querySelectorAll('[role="document"]') && document.querySelectorAll('[role="document"]').length > 0) {
            for (var i = 0; i < document.querySelectorAll('[role="document"]').length; i++) {
                document.querySelectorAll('[role="document"]')[i].removeAttribute('tabindex')
            }
        }
    }

    openDialog = () => {
        if (this.state.open) {
            const editorInstance = this.editorRef.current.getInstance();
            var AFile = {
                name: editorInstance._graphics.imageName,
                file: editorInstance.toDataURL(),
                filetype: editorInstance._graphics.imageName
            };
            this.props.callback(this.props.idfile, AFile);
        }
        this.setState({ open: !this.state.open, addButton: true });
    }

    fileToBase64 = (file) => {
        return new Promise(resolve => {
            var reader = new FileReader();
            reader.onload = function (event) {
                resolve(event.target.result);
            };
            reader.readAsDataURL(file);
        }).then(result => {
            return result;
        });
    };

    uploadImage = () => {
        var btn = document.getElementsByClassName("tui-image-editor-load-btn");
        if (btn && btn.length > 0) {
            btn[0].click();
            this.setState({ addButton: false });
        }
    }

    render() {
        const form = this.state;
        const { classes } = this.props;


        return (
            <React.Fragment>
                <Tooltip title="Editar imagem">
                    <IconButton
                        className="flex-end"
                        variant="contained"
                        color="primary"
                        onClick={() => this.openDialog()}
                    >
                        <RiImageEditFill className="text-32 text-grey" />
                    </IconButton>
                </Tooltip>
                <XAPPDialog
                    open={form.open}
                    onClose={this.openDialog}
                    fullWidth
                    fullScreen
                    key="editorImagemDialog"
                    id="editorImagemDialog"
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {'Editar imagem'}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <XAPPButton
                                type="Icon"
                                key="close"
                                aria-label="Close"
                                className="p-6"
                                onClick={() => this.openDialog()}
                                icon={"close"}
                                iconProps={"text-20 text-white"}
                            />
                        </Toolbar>
                    </AppBar>
                    <DialogContent className={classNames(classes.removeLogo, "p-0")}>
                        <ImageEditor
                            ref={this.editorRef}
                            includeUI={{

                            }}
                            usageStatistics={false}
                        />

                        {form.addButton ?
                            <div className={classNames(classes.addButton, "p-16")} key={"01"}>
                                <div
                                    className={classNames(classes.board, "flex flex-col items-center justify-center w-full rounded py-24")}
                                    role="button"
                                    onClick={() => this.uploadImage()}
                                >
                                    <MdAdd className="text-56 text-white" />
                                    <Typography className="text-16 font-300 text-center pt-16 px-32" color="inherit">{"Adicionar imagem"}</Typography>
                                </div>
                            </div>
                            :
                            <React.Fragment>
                                <XAPPButton
                                    aria-label="AddNewImagem"
                                    className={classes.addButtonSmall}
                                    onClick={() => this.uploadImage()}
                                    icon="add"
                                    type="icon"
                                    iconProps="text-24 text-white"
                                    tooltip={{ title: "Selecionar outra imagem", placement: "top" }}
                                />
                                <XAPPButton
                                    aria-label="SaveImagem"
                                    className={classes.saveButtonSmall}
                                    onClick={() => this.openDialog()}
                                    icon="save"
                                    type="icon"
                                    iconProps="text-24 text-white"
                                    tooltip={{ title: "Salvar imagem", placement: "top" }}
                                />
                            </React.Fragment>
                        }
                    </DialogContent>
                </XAPPDialog>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(EditorImagemApp);
